import { Flex } from '@chakra-ui/react';
import { InfoIcon } from '../Icons';
import { AdviceBannerProps } from './AdviceBanner.types';

export const AdviceBanner = ({ text, ...rest }: AdviceBannerProps) => {
  return (
    <Flex fontSize='s' justifyContent='space-evenly' alignItems='center' border='1px' borderRadius='full' {...rest}>
      <InfoIcon bg='white' borderRadius='full' />
      <p>{text}</p>
    </Flex>
  );
};
